import React from "react";

const SHIELD = "/brand/kit/png/mfg-shield-transparent.png";
const SIZES = { xs: 28, sm: 44, md: 72, lg: 112 };

export default function ShieldSpinner({ size = "md", label, className = "", inline = false, testId = "shield-spinner" }) {
  const px = SIZES[size] || SIZES.md;
  return (
    <div className={`${inline ? "inline-flex flex-row gap-2" : "flex flex-col gap-3 py-8"} items-center justify-center text-center ${className}`} data-testid={testId} role="status" aria-live="polite">
      <div className="mfg-shield-stage" style={{ width: px, height: px + (inline ? 0 : Math.round(px * 0.14)) }}>
        <div className="mfg-shield-badge" style={{ width: px, height: px }}>
          <img className="mfg-shield-face" src={SHIELD} alt="" width={px} height={px} draggable={false} />
          <img className="mfg-shield-face mfg-shield-back" src={SHIELD} alt="" width={px} height={px} draggable={false} />
        </div>
        {!inline && <div className="mfg-shield-floor" />}
      </div>
      {label && <div className={`font-semibold text-neutral-500 ${size === "lg" ? "text-sm tracking-wide" : "text-xs"}`}>{label}</div>}
    </div>
  );
}

export function PageLoader({ label = "Loading…" }) {
  return <ShieldSpinner size="lg" label={label} className="min-h-[40vh]" testId="page-loader" />;
}
